(function () {
  function init() {
    var stickyEl = document.querySelector("sticky-add-to-cart");
    var picker = document.querySelector("[data-dz-sub-picker]");
    if (!stickyEl || !picker) return;

    var updating = false;

    function getPickerState() {
      var activeRow = picker.querySelector("[data-dz-mode].is-active");
      var mode = activeRow ? activeRow.dataset.dzMode : "sub";
      var pane = picker.querySelector('[data-dz-mode-pane="' + mode + '"]');
      var tile =
        pane &&
        (pane.querySelector(".dz-supply-tile.is-active") ||
          pane.querySelector(".dz-supply-tile"));
      if (!tile) return null;

      var price = parseInt(tile.dataset.dzPrice, 10);
      var supply = tile.dataset.dzSupply;
      var isSub = mode === "sub";
      var comparePrice = 0;

      if (isSub) {
        var oncePane = picker.querySelector('[data-dz-mode-pane="once"]');
        if (oncePane) {
          var onceTile = oncePane.querySelector(
            '.dz-supply-tile[data-dz-supply="' + supply + '"]'
          );
          if (onceTile) comparePrice = parseInt(onceTile.dataset.dzPrice, 10);
        }
      }

      return { price: price, comparePrice: comparePrice, isSub: isSub };
    }

    function formatMoney(cents) {
      var fmt =
        (window.FoxTheme && window.FoxTheme.moneyFormat) || "${{amount}}";
      var val = (cents / 100).toFixed(2);
      var noTrailing = val.replace(/\.00$/, "");
      var noDecimals = Math.round(cents / 100).toString();
      return fmt
        .replace("{{amount_with_comma_separator}}", val.replace(".", ","))
        .replace(
          "{{amount_no_decimals_with_comma_separator}}",
          noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )
        .replace("{{amount_no_decimals}}", noDecimals)
        .replace("{{amount}}", noTrailing);
    }

    function updateStickyPrice() {
      var state = getPickerState();
      if (!state || isNaN(state.price)) return;

      var priceWrapper = stickyEl.querySelector("product-price");
      if (!priceWrapper) return;

      var html =
        '<div class="dz-sticky-price"><span class="dz-sticky-price__current">' +
        formatMoney(state.price) +
        "</span>";

      if (state.isSub && state.comparePrice > state.price) {
        html +=
          '<span class="dz-sticky-price__compare">' +
          formatMoney(state.comparePrice) +
          "</span>";
      }

      html += "</div>";

      updating = true;
      priceWrapper.innerHTML = html;
      priceWrapper.style.display = "";
      requestAnimationFrame(function () {
        updating = false;
      });
    }

    picker.addEventListener("click", function () {
      requestAnimationFrame(updateStickyPrice);
    });
    picker.addEventListener("change", function () {
      requestAnimationFrame(updateStickyPrice);
    });

    var observer = new MutationObserver(function () {
      if (updating) return;
      requestAnimationFrame(updateStickyPrice);
    });
    observer.observe(stickyEl, { childList: true, subtree: true });

    updateStickyPrice();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    requestAnimationFrame(init);
  }
})();
